var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 34,
    viewBox: "0 0 54 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9999 29.1768C24.1401 31.6446 20.4306 33.1343 16.3771 33.1343C7.33226 33.1343 0 25.717 0 16.5672C0 7.41737 7.33226 0 16.3771 0C20.4306 0 24.1401 1.48977 26.9999 3.95759C29.8597 1.48977 33.5692 0 37.6228 0C46.6676 0 53.9998 7.41737 53.9998 16.5672C53.9998 25.717 46.6676 33.1343 37.6228 33.1343C33.5692 33.1343 29.8597 31.6446 26.9999 29.1768Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 29.1768C30.5213 26.138 32.7542 21.6164 32.7542 16.5672C32.7542 11.518 30.5213 6.99631 27 3.95758C29.8598 1.48977 33.5693 0 37.6229 0C46.6677 0 53.9999 7.41737 53.9999 16.5672C53.9999 25.717 46.6677 33.1343 37.6229 33.1343C33.5693 33.1343 29.8598 31.6446 27 29.1768Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0001 29.1758C30.5213 26.1371 32.7541 21.6155 32.7541 16.5664C32.7541 11.5173 30.5213 6.99575 27.0001 3.95703C23.4789 6.99575 21.2461 11.5173 21.2461 16.5664C21.2461 21.6155 23.4789 26.1371 27.0001 29.1758Z",
    fill: "#FF5E00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/Mastercard.dc9d2b198564448dbd361a8826127dac.svg";
export { ForwardRef as ReactComponent };